<template>
    <div class="tableHeaderDateRangeFilter">
        <value-slider
            v-model="model"
            :range="range"
            :min="outerModel.min"
            :max="outerModel.max"
            :format-tooltip="
                tooltipFormatter
                    ? tooltipFormatter
                    : value => {
                          value;
                      }
            "
            connect
            tooltip
        ></value-slider>
    </div>
</template>

<script>
import ValueSlider from '../../ValueSlider';
import moment from 'moment';
import { COLUMN_TYPE } from '../columnTypes';
import { watchIsFilterActive } from './mixins/tableHeaderFilter';

function dateTooltipFormatter(value) {
    if (value === 0) {
        return 'NONE';
    }
    return moment(value).format('YYYY-MM-DD<br>HH:mm');
}

function durationTooltipFormatter(value) {
    return Math.ceil(moment.duration(value).asMinutes());
}

function numberTooltipFormatter(value) {
    return value > 0 ? value.toFixed(3) : 0;
}

function getTooltipFormatterFunctionForType(type) {
    switch (type) {
        case COLUMN_TYPE.dateTime:
            return dateTooltipFormatter;
        case COLUMN_TYPE.duration:
            return durationTooltipFormatter;
        case COLUMN_TYPE.number:
            return numberTooltipFormatter;
        default:
            return value => value;
    }
}

function isFilterActive(model) {
    return model.min !== model.from || model.max !== model.to;
}

export default {
    name: 'TableHeaderRangeFilter',

    components: {
        ValueSlider
    },
    mixins: [watchIsFilterActive],

    model: {
        prop: 'outerModel'
    },

    props: {
        outerModel: {
            type: Object,
            required: true,
            validator(value) {
                return ['min', 'definedMin', 'max', 'from', 'to'].every(key => value.hasOwnProperty(key));
            }
        },
        type: {
            type: String,
            default: ''
        }
    },

    computed: {
        model: {
            // Sync inner model with outer model
            get() {
                return [this.outerModel.from, this.outerModel.to];
            },
            set(value) {
                this.outerModel.from = value[0];
                this.outerModel.to = value[1];
                this.$emit('input', this.outerModel);
            }
        },

        range() {
            if (this.outerModel.min > 0) {
                return {
                    min: this.outerModel.min,
                    max: this.outerModel.max
                };
            }
            return {
                min: this.outerModel.min,
                '0.5%': this.outerModel.definedMin,
                max: this.outerModel.max
            };
        },

        tooltipFormatter() {
            return getTooltipFormatterFunctionForType(this.type);
        },

        isFilterActive() {
            return isFilterActive(this.outerModel);
        }
    }
};
</script>

<style lang="scss">
.tableHeaderDateRangeFilter {
    width: 240px;
    margin: 12px 0 -32px;
    padding: 0 10px;

    // Have to adjust slider styles from the outside because of multiline tooltip
    .noUi-tooltip {
        margin-top: -12px;
        line-height: 12px;
    }
}
</style>
